// LoaderContext.tsx
/**
 * Loader Context — backward-compatible API; fullscreen overlay removed.
 * Pages use section skeletons; mutations use button-level loading.
 */
import React, { createContext, useContext, useCallback, ReactNode } from "react";
import { loaderService } from "../services/loaderService";

interface LoaderContextType {
  showLoader: () => void;
  hideLoader: () => void;
  forceHide: () => void;
  isLoading: boolean;
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

export const LoaderProvider = ({ children }: { children: ReactNode }) => {
  const showLoader = useCallback(() => {
    loaderService.showLoader();
  }, []);

  const hideLoader = useCallback(() => {
    loaderService.hideLoader();
  }, []);

  const forceHide = useCallback(() => {
    loaderService.forceHide();
  }, []);

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader, forceHide, isLoading: false }}>
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) throw new Error("useLoader must be used within LoaderProvider");
  return context;
};
